export default function FacteurEmissionCo2Configuration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('facteur.emission.co2');
}

FacteurEmissionCo2Configuration.$inject = ['$translatePartialLoaderProvider'];
